export default [
  {
    title: 'Portal do Cliente',
    icon: 'ToolIcon',
    action: 'read',
    resource: 'ptc',
    children: [
      {
        title: 'Dashboard',
        route: 'dashboard-ptc',
        icon: 'AirplayIcon',
        action: 'read',
        resource: 'Acesso_Dashboard',
      },
      {
        title: 'Pedidos',
        route: 'pedidos',
        icon: 'CreditCardIcon',
        action: 'read',
        resource: 'Acesso_Pedidos',
      },
      {
        title: 'Nota Fiscal',
        route: 'notaFiscal',
        icon: 'FileTextIcon',
        action: 'read',
        resource: 'Acesso_NotaFiscal',
      },
      {
        title: 'Boleto',
        route: 'boleto',
        icon: 'PrinterIcon',
        action: 'read',
        resource: 'Acesso_Boleto',
      },
      {
        title: 'Produtos',
        route: 'produtos',
        icon: 'BoxIcon',
        action: 'read',
        resource: 'Acesso_Produtos',
      },
      // {
      //     title: 'Cadastro do Cliente',
      //     route: 'visualizar-cliente',
      //     icon: 'UserIcon',
      //     action: 'read',
      //     resource: 'Acesso_CadastroCliente'
      // },
      {
        title: 'Permissão de acesso',
        route: 'permissao-acesso',
        icon: 'UnlockIcon',
        action: 'read',
        resource: 'Acesso_Permissao',
      },
    ],
  },

];
